// src/components/FlatpickrInput.js
import { useEffect, useRef } from 'react';

const FlatpickrInput = ({ value, onChange, placeholder = "Выберите дату" }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.flatpickr) {
      console.error("Flatpickr не загружен");
      return;
    }

    const fp = window.flatpickr(inputRef.current, {
      dateFormat: "d-m-Y H:i:S",
      time_24hr: true,
      enableTime: true,
      locale: "ru",
      defaultDate: value || null,
      onChange: (selectedDates) => {
        const date = selectedDates[0];
        if (date) {
          const pad = (n) => String(n).padStart(2, '0');
          const formatted = `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
          onChange(formatted);
        } else {
          onChange('');
        }
      },
    });

    return () => fp.destroy();
  }, [onChange]);

  useEffect(() => {
    if (inputRef.current && window.flatpickr) {
      const fp = inputRef.current._flatpickr;
      if (fp) {
        fp.setDate(value || null, false);
      }
    }
  }, [value]);

  return (
    <input
      ref={inputRef}
      type="text"
      className="form-control form-control-sm datetime-picker"
      placeholder={placeholder}
      readOnly
      style={{ width: 'auto', minWidth: '180px' }}
    />
  );
};

export default FlatpickrInput;
